let concat = "<br />";

const aboutAkara = {
    "About Akara Capital Advisors" : [
        {
            question: "What is the business of Akara Capital Advisors Private Limited (Akara Capital or Akara or ACAPL)?",
            answer: "Akara is a Delhi-based non-deposit taking NBFC registered with the RBI since 2016. The company primarily provides unsecured short-term personal loans to salaried individuals through web and mobile platforms. It was started by Mr. Tushar Aggarwal, Ms. Shruti Aggarwal and Mr. Parikshit Chitalkar, who have several years of experience in the financial services industry." + concat + concat +
                    "ACAPL is owned by Morus Technologies Pte. Limited (Singapore) or MTPL, a Singapore-based neobanking start-up backed by investors like Tencent Group, Fasanara Capital, Altara Ventures, Uncorrelated Ventures, etc." + concat + concat +
                    "Akara has a fellow subsidiary EQX Analytics Private Limited (wholly owned by Morus), which is a Technology company and owns the brand 'Stashfin'. Stashfin is the lending platform which is used by Akara, and other partners (co-lenders) for disbursing loans to customers." 
                   
          },
          {
            question: "Who are the investors in Akara?",
            answer: "Akara is fully held by MTPL. The investors of MTPL include Tencent Group, Fasanara Capital, Altara Ventures, Uncorrelated Ventures, etc."
          },
          {
            question: "What are the strengths of Akara?",
            answer: "<ul><li>Strong Investors – The parent company of Akara, MTPL, is backed by strong investors like Tencent Group, Fasanara Capital, Altara Ventures, Uncorrelated Ventures, etc." + concat + concat +
                    "<li>Healthy Capitalization – The Capital Adequacy Ratio (CRAR) is 33.9% which is significantly higher than RBI minimum limit of 15%" + concat + concat +
                    "<li>Good Asset Quality - The company has a low GNPA of 4% and NNPA of 3% as on 31st Mar’23." + concat + concat +
                    "<li>Profitable - The company has posted a Profit After Tax of Rs. 26 Cr in FY23"
                   
          },
          {
            question: "What are the major risks to Akara?",
            answer: "-  Modest scale of operations; ability to raise funds in a timely manner critical for growth" + concat +
                    "-  Modest profitability on consolidated level; operating efficiency expected to improve with scale"
          },
          {
            question: "What is the Credit rating for Akara?",
            answer: "Akara has a credit rating of ICRA BBB/ Stable."
          },
          {
            question: "What is the AUM of Akara?",
            answer: "The AUM as on 31st Mar’23 is Rs. 1,465 Cr. which is up from Rs. 559 Cr. as on 31st Mar’22."
          },
          {
            question: "What is the profitability of Akara?",
            answer: "Akara reported a profit of Rs. 25.87 Crs in FY23"
          },
          {
            question: "How is the asset quality of Akara?",
            answer: "The company has a GNPA of 4.0% and NNPA of 3.0% as on 31st Mar’23."
          },
          {
            question: "What is the Capital Adequacy ratio?",
            answer: "The Capital Adequacy Ratio (CRAR) as on 31st Mar’23 is 33.92%"
          },
    ]

}

export default aboutAkara;